function mockedCounter (type, payload) {
  console.dir('[dspCounter]', { type, payload })
}

function loadScript (scriptSrc) {
  // setup counter query while script is loading
  window.DSPCounter = window.DSPCounter || function () {
    (window.DSPCounter.q = window.DSPCounter.q || []).push(arguments)
  }

  const script = document.createElement('script')
  const scriptNode = document.getElementsByTagName('script')[0]

  script.async = true
  script.src = scriptSrc

  scriptNode.parentNode.insertBefore(script, scriptNode)
}

function setDSPCounter (Vue, options) {
  const { defaultConfig, env } = options
  if (env === 'production') {
    // general DSPCounter
    DSPCounter('send', {
      sid: defaultConfig.sid,
      user_id: defaultConfig.user_id
    })

    // inject DSPCounter function to Vue
    Vue.prototype.$dspCounter = function (type, payload = {}) {
      DSPCounter(type, {
        ...defaultConfig,
        ...payload
      })
    }
  } else {
    // mocked counter for development mode
    console.warn('[dspCounter] Tracking is disabled, because env option is not "production"')

    if (options.debug) {
      console.warn('[dspCounter] DEBUG is true: you\'ll see all API calls in the console')
    }

    Vue.prototype.$dspCounter = function (type, payload = {}) {
      if (options.debug) {
        mockedCounter(type, { ...defaultConfig, ...payload })
      }
    }
  }
}

export default function install (Vue, options) {
  loadScript(options.scriptSrc)
  setDSPCounter(Vue, options)
}
